import { DraftOrdersListResponseType } from "@sellar-io/api-v2/types";
import { ReactElement, useState } from "react";
import { useNavigate } from "react-router";
import {
  CHECKOUT_BUYER_ADD_ON,
  ORDER_BUYER,
} from "../../../../../../constants/routes";
import { useNavigateToChild } from "../../../../../../hooks/useParentNavigation";
import {
  BasketContextActionEnum,
  ContextOrderBasketType,
  useBasketContext,
} from "../../../../../../hooks";
import { useDraftOrders } from "../../../../../../hooks/api/v2/useDraftOrders";
import { useSellarCurrentBusiness } from "../../../../../../hooks/useSellarCurrentBusiness.shared";
import { DeleteDraftOrderDialog } from "./components/DeleteDraftOrderDialog";
import { DraftOrderItemCard } from "./components/DraftOrderItemCard";
import { isPromotionalOrderItem } from "../../../../../stockList/categoryPage/Storefront/StorefrontPromotion/isPromotionalOrderItem";
import db from "../../../../../../db";

export const DraftOrderItem = ({
  order,
  supplierStorefrontInfo,
}: {
  order: ContextOrderBasketType;
  supplierStorefrontInfo: DraftOrdersListResponseType[number];
}): ReactElement | null => {
  const { business } = useSellarCurrentBusiness();
  const [, dispatchBasket] = useBasketContext();
  const [draftDialogActive, setDraftDialogActive] = useState<boolean>(false);
  const navigate = useNavigate();
  const navigateToChild = useNavigateToChild();
  const { deleteOrder: deleteDraftOrder } = useDraftOrders();
  const supplier = supplierStorefrontInfo.supplier;
  const supplierStorefront = supplierStorefrontInfo.storefront;

  return (
    <>
      <DraftOrderItemCard
        supplier={supplier}
        supplierStorefront={supplierStorefront}
        order={order}
        onEditBasket={() => {
          // We want to remove all promotional order items
          // because we can't guarantee that they'll be available
          // in the basket
          const updatedOrderItems =
            order.OrderItems?.filter((orderItem) => {
              return !isPromotionalOrderItem(orderItem);
            }) ?? [];

          const updatedOrder = {
            ...order,
            OrderItems: updatedOrderItems,
          };

          dispatchBasket({
            type: BasketContextActionEnum.CHANGE_ORDER,
            order: updatedOrder,
          });
          db.draftOrders.put(updatedOrder);

          navigateToChild(
            ORDER_BUYER.href({ supplierIdOrUrlId: supplier.urlId }),
          );
        }}
        onDeleteBasket={() => {
          setDraftDialogActive(true);
        }}
        onCheckoutBasket={() => {
          // We want to remove all promotional order items
          // because we can't guarantee that they'll be available
          // in the basket
          const updatedOrderItems =
            order.OrderItems?.filter((orderItem) => {
              return !isPromotionalOrderItem(orderItem);
            }) ?? [];

          const updatedOrder = {
            ...order,
            OrderItems: updatedOrderItems,
          };

          // need to populate basket before navigating to checkout
          dispatchBasket({
            type: BasketContextActionEnum.CHANGE_ORDER,
            order: updatedOrder,
          });

          db.draftOrders.put(updatedOrder);

          dispatchBasket({
            type: BasketContextActionEnum.CHANGE_SUPPLIER_RETAILER_IDS,
            // Sets to zero if the user is adding to their basket when unauthenticated
            RetailerId: business?.Retailer?.id ?? 0,
            SupplierId: supplier.id,
          });

          navigate(
            `${CHECKOUT_BUYER_ADD_ON.href({ supplierIdOrUrlId: supplier.urlId })}${location.search}`,
          );
        }}
      />

      {draftDialogActive && (
        <DeleteDraftOrderDialog
          active={draftDialogActive}
          setActive={setDraftDialogActive}
          onDelete={() => {
            if (order.SupplierId && order.RetailerId) {
              deleteDraftOrder({
                SupplierId: order.SupplierId,
                RetailerId: order.RetailerId,
                initiator: order.initiator ?? "retailer",
              });
            }
            setDraftDialogActive(false);
          }}
        />
      )}
    </>
  );
};
